export enum SubscriptionType {
  Free = 'free',
  Starter = 'starter',
  Pro = 'pro',
  Max = 'max',
  Team = 'team',
  Enterprise = 'enterprise',
}
export enum BillingCycle {
  Monthly = 'monthly',
  Yearly = 'yearly',
}

/**
 * Which of the two Weave credit prices applies to a Figma-embed run. Mirrors
 * Sinatra's `Weave::TokenGenerator::WEAVE_PRICING_TIER_*` and the Weavy backend's
 * `WeavePricingTier`. Distinct from {@link SubscriptionType}: that describes the
 * user's plan, this describes the *file's* plan discount eligibility.
 */
export enum WeavePricingTier {
  Standard = 'standard',
  Discounted = 'discounted',
}

export type Subscription = {
  type: SubscriptionType;
  name: string;
  seatsLimit: number;
  credits: number;
  startsAt: Date;
  expiresAt: Date;
};
